import { useSessionStorageValue } from "@react-hookz/web";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { BasicBrandInfo } from "~/components/basic-brand-info/basic-brand-info";
import { FullBrandInfo } from "~/components/full-brand-info/full-brand-info";
import { OnboardingSteps } from "~/components/onboarding/onboarding-steps";
import { ProtectedRoute } from "~/components/protected-route/protected-route";
import type { BrandMatch } from "~/routes/root";

export function Onboarding() {
  const { brandId, step } = useParams<BrandMatch>();
  const { set: setBrandId } = useSessionStorageValue<string | undefined>(
    "brandId",
  );

  useEffect(() => {
    setBrandId(brandId);
  }, []);

  if (!step || step === "0" || step === "1") {
    return (
      <BasicBrandInfo>
        <OnboardingSteps />
      </BasicBrandInfo>
    );
  }

  return (
    <ProtectedRoute>
      <FullBrandInfo>
        <OnboardingSteps />
      </FullBrandInfo>
    </ProtectedRoute>
  );
}
